import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouterEventService implements OnDestroy {
  private subscriptions: Subscription = new Subscription();

  constructor(private router: Router, private titleService: Title) {}

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  // 返信一覧表示判定。対象ユーザーが遷移しようとした際、案件一覧へリダイレクト
  private redirectTargetUserToTop(): boolean {
    const restrictedUserCodes = ['sales.all.technocore', 'sales.all.accessnet', 'sales.all.infinius'];
    const account = JSON.parse(localStorage.getItem('account'));
    if (account && restrictedUserCodes.includes(account.user_code)) {
      this.router.navigate(['/projects']);
      return true;
    }
    return false;
  }

  public changeTabName(): void {
    const changeTabNameSub = this.router.events.subscribe((nav: any) => {
      if (nav instanceof NavigationEnd) {
        if (nav.url.match(/login/)) {
          this.titleService.setTitle(this.createTabName('ログイン'));
        } else if (nav.url.match(/matching\/projects/)) {
          if (nav.url.match(/matching\/projects\//)) {
            this.titleService.setTitle(this.createTabName('案件詳細'));
          } else {
            this.titleService.setTitle(this.createTabName('案件一覧'));
          }
        } else if (nav.url.match(/matching\/workers/)) {
          if (nav.url.match(/matching\/workers\//)) {
            this.titleService.setTitle(this.createTabName('人材詳細'));
          } else {
            this.titleService.setTitle(this.createTabName('人材一覧'));
          }
        } else if (nav.url.match(/replies/)) {
          // 特定のuser_codeの場合はリダイレクト
          if (this.redirectTargetUserToTop()) {
            return;
          }
          this.titleService.setTitle(this.createTabName('返信一覧'));
        } else if (nav.url.match(/matching\/auto/)) {
          this.titleService.setTitle(this.createTabName('おすすめ'));
        } else if (nav.url.match(/offer/)) {
          this.titleService.setTitle(this.createTabName('提案管理'));
        } else if (nav.url.match(/mail-register/)) {
          this.titleService.setTitle(this.createTabName('案件人材管理'));
        } else if (nav.url.match(/report/)) {
          this.titleService.setTitle(this.createTabName('レポート(β)'));
        } else if (nav.url.match(/account\/setting/)) {
          this.titleService.setTitle(this.createTabName('設定'));
        } else if (nav.url.match(/registration/)) {
          this.titleService.setTitle(this.createTabName('ユーザー登録'));
        } else if (nav.url.match(/account\/setting\/notification/)) {
          this.titleService.setTitle(this.createTabName('通知設定'));
        } else if (nav.url.match(/account\/setting\/matching-condition/)) {
          this.titleService.setTitle(this.createTabName('マッチング条件設定'));
        } else if (nav.url.match(/account\/setting\/business/)) {
          this.titleService.setTitle(this.createTabName('BP設定'));
        } else if (nav.url.match(/account\/password\/change/)) {
          this.titleService.setTitle(this.createTabName('パスワード変更'));
        } else if (nav.url.match(/account\/password\/reset\/mail/)) {
          this.titleService.setTitle(this.createTabName('パスワード再発行'));
        } else if (nav.url.match(/privacy-policy-component/)) {
          this.titleService.setTitle(
            this.createTabName('プライバシーポリシー')
          );
        } else if (nav.url.match(/terms-of-service/)) {
          this.titleService.setTitle(this.createTabName('利用規約'));
        }
      }
    });
    this.subscriptions.add(changeTabNameSub);
  }

  private createTabName(page: string) {
    return `${page} ｜ Qoala`;
  }
}
